import { TicketsClient } from './../../core/services/api.service';
import { Injectable } from '@angular/core';
import { TicketsModel } from '@core/services/api.service';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CreateTicketAction, CreateTicketFailAction, CreateTicketSuccessAction, LoadLoggedTicketFailAction, LoadLoggedTicketListAction, LoadLoggedTicketSuccessAction } from './log-tickets.actions';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { CustomTicketApplicationService } from '@core/services/tickets/custom.TickeApplicationService';
import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';

export class LogTicketsStateModel {
    public showMenu: boolean;
    public isLoading: boolean;
    public isMobileMode: boolean;
    public showSpinner: boolean;
    error: any;
    public tickets: TicketsModel[];

}

@State<LogTicketsStateModel>({
    name: 'logtickets',
    defaults: {
        showMenu: true,
        isLoading: true,
        isMobileMode: false,
        error: null,
        showSpinner: false,
        tickets: [],
    }
})
@Injectable()
export class LogTicketsState {
    constructor(private loggedTicketsService: TicketsClient, private customTicketService: CustomTicketApplicationService) {}

    @Selector()
    static getIsLoading(state: LogTicketsStateModel) {
        return state.isLoading;
    }

    @Selector()
    static getLoggedTickets(state: LogTicketsStateModel) {
        return state.tickets;
    }


    @Action(LoadLoggedTicketListAction)
    loadLoggedTicketsListAction({ dispatch, patchState }: StateContext<LogTicketsStateModel>, action: LoadLoggedTicketListAction) {
        patchState({ isLoading: true });

        return this.loggedTicketsService.getAllTickets().pipe(
            tap((tickets) => dispatch(new LoadLoggedTicketSuccessAction({ tickets }))),
            catchError((err) => dispatch(new LoadLoggedTicketFailAction()))
        );
    }

    @Action(LoadLoggedTicketSuccessAction)
    loadLoggedTicketsListSuccessAction({ dispatch, patchState }: StateContext<LogTicketsStateModel>, action: LoadLoggedTicketSuccessAction) {
        patchState({
            isLoading: false,
            tickets: action.payload.tickets
        })
    }

    @Action(LoadLoggedTicketFailAction)
    loadLoggedTicketsListFailAction(ctx: StateContext<LogTicketsStateModel>, action: LoadLoggedTicketFailAction) {
        ctx.patchState({
            isLoading: false,
            tickets: []
       });
    }


    @Action(CreateTicketAction)
    createTicket(ctx: StateContext<LogTicketsStateModel>, action: CreateTicketAction) {
    ctx.patchState({ isLoading: true });

    return this.customTicketService.createTicketsWithImage(action.payload).pipe(
        filter((event: HttpEvent<any>) => event.type === HttpEventType.Response),
        map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
            return event.body as TicketsModel;
        }
        return null;
        }),
        tap((ticket: TicketsModel) => {
        if (ticket) {
            ctx.dispatch(new CreateTicketSuccessAction({ ticket }));
        }
        }),
        catchError(error => {
        ctx.dispatch(new CreateTicketFailAction(error));
        return of(error);
        })
    );
    }

    @Action(CreateTicketSuccessAction)
    createTicketSuccess(ctx: StateContext<LogTicketsStateModel>, action: CreateTicketSuccessAction) {
        const state = ctx.getState();
        ctx.patchState({
            tickets: [action.payload.ticket, ...state.tickets],
            isLoading: false,
            error: null
        });
    }

    @Action(CreateTicketFailAction)
    createTicketFail(ctx: StateContext<LogTicketsStateModel>, action: CreateTicketFailAction) {
        ctx.patchState({
            isLoading: false,
            error: action.error
        });
    }

}
